import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { CheckmarkCircledIcon } from 'assets/icons'
import PropTypes from 'prop-types'

const PrivacyOption = ({ checked, title, description }) => {
   return (
      <div className="flex gap-5 w-[500px] sm:w-[500px] p-5 text-black border-b border-solid border-black/10 last:border-b-0">
         <div className="flex-none pt-1">
            {checked && <CheckmarkCircledIcon width="20px" height="20px" color="#48c163" />}
            {!checked && <div className="w-[20px] h-[20px] rounded-full border-2 border-solid border-black/30" />}
         </div>
         <div>
            <div className="flex items-center text-sm font-medium">{title}</div>
            <div className="text-xs opacity-50 max-w-[360px]">
               {description}
            </div>
         </div>
      </div>
   )
}

PrivacyOption.propTypes = {
   checked: PropTypes.bool.isRequired,
   title: PropTypes.string.isRequired,
   description: PropTypes.string.isRequired
}

const PrivacyFeature = ({ active }) => {
   const [visible, setVisible] = useState(false)

   useEffect(() => {
      if (active) {
         setTimeout(() => {
            setVisible(true)
         }, 200)
      } else {
         setVisible(false)
      }
   }, [active])

   return (
      <div className="w-full h-full">
         <div
            className={classNames(
               'absolute top-[12%] left-[20%] w-[90%] rounded-3xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)] transition-all duration-700 delay-50',
               visible ? 'translate-y-0 opacity-70' : 'translate-y-10 opacity-0'
            )}>
            <img
               className="w-full"
               src="/assets/custom/communities/images/features/privacy/2.png"
               alt="Advanced Privacy Settings"
            />
         </div>

         <div
            className={classNames(
               'absolute top-[20%] sm:top-[38%] -left-[50%] sm:left-[12%] w-[300%] sm:w-[88%] rounded-l-3xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)] border border-solid border-white/0 bg-white/95 backdrop-blur-sm transition-all duration-700 delay-100 py-1 scale-[60%] sm:scale-100',
               visible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
            )}>
            <PrivacyOption
               checked={false}
               title="Open"
               description="Anyone can see and join this community."
            />
            <PrivacyOption
               checked
               title="Private"
               description="Anyone can see this Site's community, but they must be invited to become of Member of it."
            />
            <PrivacyOption
               checked={false}
               title="Secret"
               description="All users must log in to see any part of this Site's community. Only people that are invited can become a Member."
            />
         </div>
      </div>
   )
}

PrivacyFeature.propTypes = {
   active: PropTypes.bool.isRequired
}

export default PrivacyFeature
